// extracted by mini-css-extract-plugin
var _1 = "EditorUploader-module__upgradeInfo--Bfnwb";
export { _1 as "upgradeInfo" }
